import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "./LeaveApply.css";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelLeave,
  createLeave,
  getLeaveBalanceList,
  getLeaveList,
  getLeaveTypeList,
} from "../../Redux/Leave/Action";
import Swal from "sweetalert2";
import { FaInfoCircle } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { FiCheckCircle } from "react-icons/fi";

const LeaveApply = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const [show, setShow] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [infoLeaveData, setInfoLeaveData] = useState(null);
  const handleShow = () => setShow(true);
  const [clList, setClList] = useState("");
  const { leavetypelist, leavebalancelist, leavelist } = useSelector(
    (store) => store.leave
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    dispatch(getLeaveTypeList(token));
    dispatch(getLeaveBalanceList(token, loginId, 'Apply'));
    dispatch(getLeaveList(token, loginId));
  }, [dispatch, token, loginId]);

  useEffect(() => {
    if (leavebalancelist) {
      const list = leavebalancelist.filter((leave) => leave.leaveCode === "CL")
      setClList(list?.[0]);
    }

  }, [leavebalancelist])

  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const [leaveData, setLeaveData] = useState({
    userId: loginId,
    leaveCode: "",
    dayType: "F",
    startDate: formatDate(new Date()),
    endDate: formatDate(new Date()),
    remark: "",
    actionType: "INSERT",
  });

  const statusMap = {
    S: "Success",
    A: "Applied",
    R: "Reverted",
  };
  const statusColorMap = {
    S: "text-success",
    A: "text-primary",
    R: "text-danger",
  };

  const handleChange = (e) => {
    const { id, value } = e.target;

    setLeaveData((prevData) => {
      let updatedData = {
        ...prevData,
        [id]: value,
      };

      if (updatedData.dayType === "H") {
        updatedData.endDate = updatedData.startDate;
      }

      return updatedData;
    });
  };

  const handleDateChange = (date, name) => {
    setLeaveData((prevData) => {
      let updatedData = {
        ...prevData,
        [name]: date ? format(date, "yyyy-MM-dd") : "",
      };

      //  For Half CL, endDate = startDate
      if (updatedData.dayType === "H" && name === "startDate") {
        updatedData.endDate = updatedData.startDate;
      }

      //  If startDate changes and is after endDate, auto-adjust endDate
      if (name === "startDate") {
        const start = new Date(date);
        const end = new Date(prevData.endDate);

        if (!prevData.endDate || start > end) {
          updatedData.endDate = format(start, "yyyy-MM-dd");
        }
      }

      return updatedData;
    });
  };

  const handleClose = () => {
    clearLeaveInputFields();
    setShow(false);
  };

  const handleInfoClose = () => {
    setShowInfo(false);
    setInfoLeaveData(null);
  };

  const clearLeaveInputFields = () => {
    setLeaveData({
      userId: loginId,
      leaveCode: "",
      dayType: "F",
      startDate: formatDate(new Date()),
      endDate: formatDate(new Date()),
      remark: "",
      actionType: "INSERT",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!leaveData.startDate || !leaveData.endDate) {
      alert("Both Start And End Date Is Required");
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      setIsSubmitting(true);
      dispatch(createLeave(token, leaveData))
        .then((response) => {
          if (response.statusMessage === "SUCCESS") {
            dispatch(getLeaveBalanceList(token, loginId, 'Apply'));
            dispatch(getLeaveList(token, loginId));
            setShow(false);
            clearLeaveInputFields();
            Swal.fire({
              title: "Success!",
              text: response.statusDesc,
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: response.statusDesc,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error initiating the leave details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  const handleCancelLeave = async (leaveId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(cancelLeave(leaveId, token))
        .then((response) => {
          if (response.statusMessage === "SUCCESS") {
            dispatch(getLeaveBalanceList(token, loginId, 'Apply'));
            dispatch(getLeaveList(token, loginId));
            Swal.fire({
              title: "Success!",
              text: response.statusDesc,
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: response.statusDesc,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error initiating the leave details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };


  const handleInfoClick = (leave) => {
    setInfoLeaveData(leave);
    setShowInfo(true);
  }

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">

          <div className="card p-4">
            <div className="card shadow-sm border-0 mb-1 w-100">
              <div
                className="card-header d-flex justify-content-between align-items-center text-white"
                style={{
                  background: "linear-gradient(90deg, #1e3c72 0%, #2a5298 100%)",
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                }}
              >
                <h4 className="mb-0 fw-semibold">Leave Details</h4>
                <button
                  type="button"
                  className="btn btn-light btn-sm fw-semibold apply-leave"
                  onClick={handleShow}
                >
                  APPLY LEAVE
                </button>
              </div>
            </div>


            <div className="container my-2">
              {/* 3 Cards Section */}
              <div className="d-flex justify-content-center align-items-center gap-5">
                <div className="text-center">
                  <h6 className="mb-1">Total Leave Entitlement (CL): {clList?.leaveDays + clList?.appliedDays || 0}</h6>
                </div>

                <div className="text-center">
                  <h6 className="mb-1">Leave Utilized: {clList?.appliedDays || 0}</h6>
                </div>

                <div className="text-center">
                  <h6 className="mb-1">Leave Balance Remaining: {clList?.leaveDays || 0}</h6>
                </div>

              </div>

            </div>



            <div className="row mt-1">
              <div className="col-md-6 mb-3">
                <div className="card shadow-sm h-100 rounded-4">
                  <div className="card-body text-center">
                    <h5 className="card-title" style={{
                      display: "inline-block",
                      backgroundColor: "lightcyan",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      textDecoration: "none"
                    }}>Applied CL</h5>
                    <table className="table table-bordered table-striped table-hover table-responsive">
                      <thead>
                        <tr>
                          <th className="thead-leave">SN</th>
                          <th className="thead-leave">Start</th>
                          <th className="thead-leave">End</th>
                          <th className="thead-leave">Days</th>
                          <th className="thead-leave">Status</th>
                          <th className="thead-leave">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leavelist && leavelist.filter((leave) => leave.leaveCode === "CL").length > 0 ? (
                          leavelist
                            .filter((leave) => leave.leaveCode === "CL")
                            .map((leave, index) => {
                              const [day, month, year] = leave.startDate.split("-");
                              const parsedStartDate = new Date(
                                `${year}-${month}-${day}`
                              );

                              const isFutureDate = parsedStartDate > new Date();

                              return (
                                <tr key={index} style={{ fontSize: "14px" }}>
                                  <td>{index + 1}</td>
                                  <td className="td-leave">{leave?.startDate ?? "-"}</td>
                                  <td className="td-leave">{leave?.endDate ?? "-"}</td>
                                  <td>{leave?.noOfDays ?? "-"}</td>
                                  <td className={`${statusColorMap[leave?.status]} fw-bold`}>
                                    {statusMap[leave?.status] ?? leave?.status ?? "-"}
                                  </td>

                                  <td>
                                    <Tooltip text="Info">
                                      <FaInfoCircle onClick={() => handleInfoClick(leave)} className="text-primary cursor-pointer me-2" />
                                    </Tooltip>
                                    {leave.leaveCode === "CL" && isFutureDate && (
                                      <Tooltip text="Delete">
                                        <MdDeleteForever onClick={() => handleCancelLeave(leave.leaveId)} className="text-danger cursor-pointer me-2" size={20} />
                                      </Tooltip>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                        ) : (
                          <tr>
                            <td colSpan="7">No leave data available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* <div className="col-md-4 mb-3">
                <div className="card shadow-sm h-100 rounded-4">
                  <div className="card-body text-center">
                    <h5 className="card-title" style={{
                      display: "inline-block",
                      backgroundColor: "lightcyan",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      textDecoration: "none"
                    }}>Applied COM</h5>
                    <table className="table table-bordered table-striped table-hover table-responsive">
                      <thead>
                        <tr>
                          <th className="thead-leave">SN</th>
                          <th className="thead-leave">Start</th>
                          <th className="thead-leave">End</th>
                          <th className="thead-leave">Days</th>
                          <th className="thead-leave">Status</th>
                          <th className="thead-leave">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leavelist && leavelist.filter((leave) => leave.leaveCode === "COM").length > 0 ? (
                          leavelist
                            .filter((leave) => leave.leaveCode === "COM")
                            .map((leave, index) => {
                              const [day, month, year] = leave.startDate.split("-");
                              const parsedStartDate = new Date(
                                `${year}-${month}-${day}`
                              );

                              return (
                                <tr key={index} style={{ fontSize: "13px" }}>
                                  <td>{index + 1}</td>
                                  <td className="td-leave">{leave?.startDate ?? "-"}</td>
                                  <td className="td-leave">{leave?.endDate ?? "-"}</td>
                                  <td>{leave?.noOfDays ?? "-"}</td>
                                  <td className={`${statusColorMap[leave?.status]} fw-bold`}>
                                    {statusMap[leave?.status] ?? leave?.status ?? "-"}
                                  </td>
                                  <td>
                                    <Tooltip text="Info">
                                      <FaInfoCircle onClick={() => handleInfoClick(leave)} className="text-primary cursor-pointer" />
                                    </Tooltip>
                                  </td>
                                </tr>
                              );
                            })
                        ) : (
                          <tr>
                            <td colSpan="7">No leave data available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                  </div>
                </div>
              </div> */}

              <div className="col-md-6 mb-3">
                <div className="card shadow-sm h-100 rounded-4">
                  <div className="card-body text-center">
                    <h5 className="card-title" style={{
                      display: "inline-block",
                      backgroundColor: "lightcyan",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      textDecoration: "none"
                    }}>Applied LOP</h5>
                    <table className="table table-bordered table-striped table-hover table-responsive">
                      <thead>
                        <tr>
                          <th className="thead-leave">SN</th>
                          <th className="thead-leave">Start</th>
                          <th className="thead-leave">End</th>
                          <th className="thead-leave">Days</th>
                          <th className="thead-leave">Status</th>
                          <th className="thead-leave">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leavelist && leavelist.filter((leave) => leave.leaveCode === "LOP").length > 0 ? (
                          leavelist
                            .filter((leave) => leave.leaveCode === "LOP")
                            .map((leave, index) => {
                              const [day, month, year] = leave.startDate.split("-");
                              const parsedStartDate = new Date(
                                `${year}-${month}-${day}`
                              );

                              return (
                                <tr key={index} style={{ fontSize: "14px" }}>
                                  <td>{index + 1}</td>
                                  <td className="td-leave">{leave?.startDate ?? "-"}</td>
                                  <td className="td-leave">{leave?.endDate ?? "-"}</td>
                                  <td>{leave?.noOfDays ?? "-"}</td>
                                  <td className={`${statusColorMap[leave?.status]} fw-bold`}>
                                    {statusMap[leave?.status] ?? leave?.status ?? "-"}
                                  </td>
                                  <td>
                                    <Tooltip text="Info">
                                      <FaInfoCircle onClick={() => handleInfoClick(leave)} className="text-primary cursor-pointer" />
                                    </Tooltip>
                                  </td>
                                </tr>
                              );
                            })
                        ) : (
                          <tr>
                            <td colSpan="7">No leave data available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="leave-notes-container">
              <em className="text-danger fw-bold">Leave Policy Notes :-</em>
              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>
                  New joiners do not receive any leave during the first 6 months (Probation Period).
                  They must apply for LOP during this period.
                </em>
              </div>

              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>
                  Every permanent employee earns one leave per month, credited as 6 leaves on
                  1st January and 1st July.
                </em>
              </div>

              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>
                  If an employee does not have sufficient leave balance, they must apply for LOP.
                </em>
              </div>

              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>
                  If an employee leaves the organization before the year ends, any advanced leave
                  availed will be adjusted during the final settlement.
                </em>
              </div>

              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>Holidays are not counted as leave days.</em>
              </div>

              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>
                  If both Friday and Monday are applied as leave, the total leave count will be
                  4 days, as Saturday and Sunday are included.
                </em>
              </div>
            </div>
          </div>



          <div
            className={`modal leave-modal ${show ? "d-block" : "d-none"}`}
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">LEAVE APPLICATION</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    {/* Row 1: Leave Type, Start Date, End Date */}
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label htmlFor="leaveCode" className="form-label">
                          Leave Type <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          id="leaveCode"
                          value={leaveData.leaveCode || ""}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select..</option>
                          {leavetypelist && (
                            <>
                              {(clList?.leaveDays > 0) &&
                                leavetypelist
                                  .filter((leave) => leave.leaveCode === "CL")
                                  .map((leave, index) => (
                                    <option key={index} value={leave.leaveCode}>
                                      {`${leave.leaveDesc} (${leave.leaveCode})`}
                                    </option>
                                  ))}

                              {((clList?.leaveDays ?? 0) === 0) &&
                                leavetypelist
                                  .filter((leave) => leave.leaveCode !== "CL" && leave.leaveCode !== "COM")
                                  .map((leave, index) => (
                                    <option key={index} value={leave.leaveCode}>
                                      {`${leave.leaveDesc} (${leave.leaveCode})`}
                                    </option>
                                  ))}
                            </>
                          )}
                        </select>
                      </div>
                      {/* {clList?.leaveDays > 0 && ( */}
                        <div className="col-md-6">
                          <label htmlFor="leaveCode" className="form-label">
                            Day Type <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            id="dayType"
                            value={leaveData.dayType || ""}
                            onChange={handleChange}
                            required
                          >
                            <option value="F" selected>Full Day</option>
                            <option value="H">Half Day</option>
                          </select>
                        </div>
                      {/* )} */}

                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label htmlFor="startDate" className="form-label">
                          Start Date <span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          selected={leaveData.startDate ? new Date(leaveData.startDate) : null}
                          onChange={(date) => handleDateChange(date, "startDate")}
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Start Date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))}
                          maxDate={new Date(new Date().getFullYear(), 11, 31)}
                          onKeyDown={(event) => event.preventDefault()}
                        />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="endDate" className="form-label">
                          End Date <span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          selected={leaveData.endDate ? new Date(leaveData.endDate) : null}
                          onChange={(date) => handleDateChange(date, "endDate")}
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="End Date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          minDate={leaveData.startDate ? new Date(leaveData.startDate) : new Date()}
                          maxDate={new Date(new Date().getFullYear(), 11, 31)}
                          onKeyDown={(event) => event.preventDefault()}
                          disabled={leaveData.dayType === "H"}
                        />
                      </div>
                    </div>


                    {/* Row 2: Description */}
                    <div className="mb-3">
                      <label htmlFor="remark" className="form-label">
                        Description <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        id="remark"
                        rows="3"
                        placeholder="Enter a description"
                        value={leaveData.remark || ""}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                    <hr />
                    <div className="text-center">
                      <button type="submit" className="btn btn-success" disabled={isSubmitting}>
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {showInfo && (
            <div
              className="modal fade leave-modal show"
              tabIndex="-1"
              style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.5)",
              }}
            >
              <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">LEAVE DESCRIPTION</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleInfoClose}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>
                      <strong>Leave Period:</strong> {infoLeaveData.startDate} to {infoLeaveData.endDate}
                    </p>
                    <p>
                      <strong>Remark:</strong> {infoLeaveData.remark || "N/A"}
                    </p>
                  </div>

                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default LeaveApply;
